// extracted by mini-css-extract-plugin
export default {"lazy-image":"style_lazy-image__s4493"};